import React, {
  useState,
  useEffect,
  useCallback,
  useContext,
  createContext,
  useMemo,
} from 'react';
import { useAuth } from 'hooks/auth';
import { useCadSecador } from 'hooks/providers/cadastros/cadastroRastreabilidade/secadores';

const SelectSecadorContext = createContext({});

export function SelectSecadorProvider({ children }) {
  const { isAuth, token } = useAuth();
  const { addSecador, editSecador } = useCadSecador();

  const [dados, setDados] = useState({});
  const [options, setOptions] = useState([]);

  const onSubmitInsert = useCallback(
    async (data, onChange) => {
      try {
        const response = await addSecador(data);

        if (response) {
          setDados(response);
          setOptions((old) => [...old, response]);
          onChange(response);
        }
      } finally {
      }
    },
    [addSecador],
  );

  const onSubmitUpdate = useCallback(
    async (id, data, onChange) => {
      try {
        const response = await editSecador({ id, ...data });

        if (response) {
          setOptions((old) =>
            old.map((item) =>
              Number(item.id) === Number(id) ? { ...item, ...response } : item,
            ),
          );
          setDados(response);
          onChange(response);
        }
      } finally {
      }
    },
    [editSecador],
  );

  useEffect(() => {
    if (!isAuth && token === 'initial') {
      setDados([]);
    }
  }, [isAuth, token]);

  const value = useMemo(
    () => ({
      onSubmitInsert,
      onSubmitUpdate,
      dados,
      setDados,
      options,
      setOptions,
    }),
    [onSubmitInsert, onSubmitUpdate, dados, options],
  );

  return (
    <SelectSecadorContext.Provider value={value}>
      {children}
    </SelectSecadorContext.Provider>
  );
}

export function useSelectSecador() {
  const context = useContext(SelectSecadorContext);

  if (!context)
    throw new Error('useSelectSecador must be used within an AuthProvider');

  return context;
}
